import { useAuth } from "@clerk/clerk-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();

  const request = async (path, { method = "GET", body, isForm } = {}) => {
    const token = await getToken();
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    let payload = body;
    if (body && !isForm) {
      headers["Content-Type"] = "application/json";
      payload = JSON.stringify(body);
    }
    const res = await fetch(`${BASE}${path}`, { method, headers, body: payload });
    if (!res.ok) {
      const text = await res.text();
      const ct = res.headers.get("content-type") || "";
      let detail;
      if (ct.includes("application/json")) {
        try { detail = JSON.parse(text).detail; } catch (e) { /* ignore */ }
      }
      if (!detail) {
        detail = res.status >= 500 || res.status === 424
          ? "The AI service is busy right now. Please try again in a moment."
          : (res.statusText || "Request failed");
      }
      const err = new Error(detail);
      err.status = res.status;
      throw err;
    }
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return res.json();
    return res;
  };

  const download = async (path, filename) => {
    const token = await getToken();
    const res = await fetch(`${BASE}${path}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error("Download failed");
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return {
    get: (p) => request(p),
    post: (p, b) => request(p, { method: "POST", body: b }),
    patch: (p, b) => request(p, { method: "PATCH", body: b }),
    put: (p, b) => request(p, { method: "PUT", body: b }),
    del: (p) => request(p, { method: "DELETE" }),
    upload: (p, form) => request(p, { method: "POST", body: form, isForm: true }),
    download,
    blob: async (p) => {
      const token = await getToken();
      const res = await fetch(`${BASE}${p}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error("load failed");
      return URL.createObjectURL(await res.blob());
    },
  };
}

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
